import React, { Suspense } from 'react';

import { CircularProgress } from '@mui/material';
import lazyRetry from '../lazyRetry';
const styles = {
  progress: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
};

const Loading = () => (
  <div style={styles.progress}>
    <CircularProgress color="secondary" style={{ verticalAlign: 'middle' }} />
  </div>
);

const SupportContent = lazyRetry(() => import('./SupportContent'), 'SupportContent');

function LoadableSupportContent(props) {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <SupportContent {...props} />
      </Suspense>
    </>
  );
}

export default LoadableSupportContent;
